import Backbone from 'backbone'

import store from '../../store'
import { GoodsModel } from '../../store/goods.model'
import { addAttribute } from '../../manager/collection.controller'

export var GachaCollection = Backbone.Collection.extend({
  model: GoodsModel,
  parse: function (data) {
    return addAttribute(data, { disablePmangBonus: true })
  },
  sync: function (method, model, options) {
    if (method === 'read') {
      options.success(store.list.get('gacha'))
    }
  },
})
